import { useSupabaseUser } from '~/composables/useSupabaseUser';

export default defineNuxtRouteMiddleware(() => {
	const user = useSupabaseUser();

	if (user.value) {
		return navigateTo('/');
	}
});
